/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { env } from '@env/environment-factory';
import { JwtConfig } from '@jjmhalew/angular-jwt';
import { Store } from '@ngxs/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { firstValueFrom, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { AuthState } from './state/auth.state';

export function csJwtOptionsProvider(store: Store, oauthService: OAuthService): JwtConfig {
    const apiBase = new URL(env.apiBase);
    const apiDomain = apiBase.host;
    const token$ = store
        .selectOnce(AuthState.activeMethod)
        .pipe(
            concatMap((activeMethod) => activeMethod === 'oidc'
                ? of(oauthService.getAccessToken())
                : store.selectOnce(AuthState.token)
            ),
        );
    return {
        tokenGetter: () => firstValueFrom(token$),
        allowedDomains: [apiDomain],
        disallowedRoutes: [
            /assets\/.+/,
            `${env.apiBase}/api`,
            `${env.apiBase}/api/config`,
            `${env.apiBase}/api/auth/login`,
            `${env.apiBase}/api/auth/refresh`,
            `${env.apiBase}/api/auth/config`,
            `${env.apiBase}/api/auth/logout`,
            `${env.apiBase}/api/auth/userinfo`,
            `${env.apiBase}/api/video/watch`,
            `${env.apiBase}/api/storage/direct`,
            `${env.apiBase}/api/auth/password/forgot`,
            `${env.apiBase}/api/auth/password/resetcheck`,
            `${env.apiBase}/api/auth/password/resetforgotten`,
            `${env.apiBase}/api/auth/password/complexity`,
            `${env.apiBase}/api/auth/confirm`,
            `${env.apiBase}/api/auth/confirm/check`,
        ],
    };
}
